import React from "react";
import './Sponsore.css';    

type Props = {
    title ?: string;
    description ?: string
};
const defaultDescription = `SUCCIT is created by young people, for young people.

We’re here to empower you, to support your journey, amplify your voice, and help you create real impact.

At SUCCIT, we don’t just sponsor, we partner. We believe in growing together, creating collaborations where both sides reach the full fulfillment of their potential.

Because it’s not only about chasing your goals, it’s about how you do it. With confidence. With identity. With style.

If you’re driven, ambitious, and ready to stand out, you’re exactly who we’re looking for.

Let’s be partners.
Let our in-kind sponsorship be the only thing you need to stay stylish while chasing your goals and reaching your full potential.`;

const Sponsore: React.FC<Props> = ({ title, description }) => {
  const paragraphs = (description || defaultDescription)
    .split("\n\n")
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  return (
    <div className ="sponsore">
      <h2 className="sponsore-title">{title}</h2>
      <div className="sponsore-description">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
};

export default Sponsore;
